import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'privacy' | 'terms';
}
const privacyContent = <div className="space-y-6" data-id="element-139">
    <h2 className="font-serif text-3xl font-bold text-earth-dark" data-id="element-140">
      Política de Privacidad
    </h2>
    <p className="text-sm text-earth-medium" data-id="element-141">
      Última actualización: abril 2026
    </p>

    <section className="space-y-3" data-id="element-142">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-143">
        1. Información que Recopilamos
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-144">
        Recopilamos información personal que nos proporcionas voluntariamente al
        realizar una compra, como tu nombre, dirección de correo electrónico y
        datos de pago. No almacenamos información de tarjetas de crédito; los
        pagos son procesados por plataformas de pago seguras de terceros.
      </p>
    </section>

    <section className="space-y-3" data-id="element-145">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-146">
        2. Uso de la Información
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-147">
        Utilizamos tu información personal para: procesar y entregar tu compra,
        enviarte el producto digital adquirido, comunicarnos contigo sobre tu
        pedido, y enviarte información relevante sobre nuestros productos (solo
        si has dado tu consentimiento).
      </p>
    </section>

    <section className="space-y-3" data-id="element-148">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-149">
        3. Protección de Datos
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-150">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Utilizamos cifrado SSL para todas
        las transmisiones de datos.
      </p>
    </section>

    <section className="space-y-3" data-id="element-151">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-152">
        4. Cookies
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-153">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar la
        funcionalidad del sitio.
      </p>
    </section>

    <section className="space-y-3" data-id="element-154">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-155">
        5. Terceros
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-156">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. Esto no incluye a terceros de confianza que nos ayudan a
        operar nuestro sitio web o a realizar nuestro negocio, siempre que
        dichas partes acuerden mantener esta información confidencial.
      </p>
    </section>

    <section className="space-y-3" data-id="element-157">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-158">
        6. Tus Derechos
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-159">
        Tienes derecho a acceder, rectificar, eliminar o limitar el uso de tus
        datos personales. Para ejercer estos derechos, puedes contactarnos a
        través de los canales disponibles en nuestro sitio.
      </p>
    </section>
  </div>;
const termsContent = <div className="space-y-6" data-id="element-160">
    <h2 className="font-serif text-3xl font-bold text-earth-dark" data-id="element-161">
      Términos y Condiciones
    </h2>
    <p className="text-sm text-earth-medium" data-id="element-162">
      Última actualización: abril 2026
    </p>

    <section className="space-y-3" data-id="element-163">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-164">
        1. Aceptación de los Términos
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-165">
        Al acceder a este sitio web y realizar una compra, aceptas estar sujeto
        a estos Términos y Condiciones de uso. Si no estás de acuerdo con alguna
        parte de estos términos, no debes utilizar nuestro sitio ni adquirir
        nuestros productos.
      </p>
    </section>

    <section className="space-y-3" data-id="element-166">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-167">
        2. Producto Digital
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-168">
        El producto ofrecido es una guía digital en formato PDF. Una vez
        completada la compra, recibirás acceso inmediato al producto a través
        del correo electrónico proporcionado. El contenido es para uso personal
        y no puede ser redistribuido, copiado o compartido sin autorización
        expresa.
      </p>
    </section>

    <section className="space-y-3" data-id="element-169">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-170">
        3. Política de Reembolso
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-171">
        Debido a la naturaleza digital del producto, no se ofrecen reembolsos
        una vez que el producto ha sido entregado y descargado. Si experimentas
        problemas técnicos con la descarga, contáctanos y te ayudaremos a
        resolver el inconveniente.
      </p>
    </section>

    <section className="space-y-3" data-id="element-172">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-173">
        4. Propiedad Intelectual
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-174">
        Todo el contenido de este sitio web y del producto digital, incluyendo
        textos, gráficos, logotipos, imágenes y metodologías, es propiedad de
        Método de la Calma Conectada y está protegido por las leyes de propiedad
        intelectual aplicables.
      </p>
    </section>

    <section className="space-y-3" data-id="element-175">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-176">
        5. Descargo de Responsabilidad
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-177">
        La información proporcionada en esta guía es de carácter educativo e
        informativo. No sustituye el consejo médico, psicológico o profesional.
        Si tu hijo tiene un diagnóstico de ADHD, te recomendamos trabajar en
        conjunto con profesionales de la salud calificados. Los resultados
        pueden variar según cada familia y situación individual.
      </p>
    </section>

    <section className="space-y-3" data-id="element-178">
      <h3 className="font-serif text-xl font-semibold text-earth-dark" data-id="element-179">
        6. Modificaciones
      </h3>
      <p className="text-earth-medium leading-relaxed" data-id="element-180">
        Nos reservamos el derecho de modificar estos Términos y Condiciones en
        cualquier momento. Las modificaciones entrarán en vigor inmediatamente
        después de su publicación en el sitio web. El uso continuado del sitio
        después de cualquier cambio constituye tu aceptación de los nuevos
        términos.
      </p>
    </section>
  </div>;
export function LegalModal({
  isOpen,
  onClose,
  type
}: LegalModalProps) {
  return <AnimatePresence data-id="element-181">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-earth-dark/60 backdrop-blur-sm" onClick={onClose} data-id="element-182">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-cream w-full max-w-2xl max-h-[85vh] rounded-3xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-183">
            <div className="flex items-center justify-between p-6 border-b border-terracotta/15" data-id="element-184">
              <span className="font-serif text-lg font-semibold text-earth-dark" data-id="element-185">
                {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </span>
              <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-terracotta/10 transition-colors text-earth-medium hover:text-earth-dark" aria-label="Cerrar" data-id="element-186">
                <XIcon size={20} data-id="element-187" />
              </button>
            </div>
            <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-188">
              {type === 'privacy' ? privacyContent : termsContent}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}